var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parentMarket"},[_c('powerFutures'),_c('gasFutures'),_c('foreignEx')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }